<div class="row" *ngIf="(payDetail | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Load #</label>
            </div>
            <div class="col-sm-9">
                <select name="quoteOrderLineID" [(ngModel)]="payDetail.quoteOrderLineId" class="form-select" [ngClass]="{'border-danger': payDetail.quoteOrderLineId == 0}" required>
                    <option *ngFor="let line of quoteOrderLineList" value="{{line.quoteOrderLineID}}">{{line.legNumber}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Assign To</label>
            </div>
            <div class="col-sm-9">
                <select name="assignToId" [(ngModel)]="payDetail.assignToId" class="form-select" [ngClass]="{'border-danger': payDetail.assignToId == 0}" required>
                    <option *ngFor="let company of thirdPartyCompanyList" value="{{company.thirdPartyCompanyID}}">{{company.thirdPartyCompanyCode}} - {{company.thirdPartyCompanyName}}</option>
                </select>
            </div>
        </div>
        <!--<div class="row">
        <div class="col-sm-3">
            <label class="font-weight-bold">Pay To</label>
        </div>
        <div class="col-sm-9">
            <select name="payToId" [(ngModel)]="payDetail.payToId" class="form-select" [ngClass]="{'border-danger': payDetail.payToId == 0}" required>
                <option *ngFor="let company of thirdPartyCompanyList" value="{{company.thirdPartyCompanyID}}">{{company.thirdPartyCompanyCode}} - {{company.thirdPartyCompanyName}}</option>
            </select>
        </div>
    </div>-->
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Type</label>
            </div>
            <div class="col-sm-9">
                <select name="payDetailType" [(ngModel)]="payDetail.payDetailTypeId" class="form-select" [ngClass]="{'border-danger': payDetail.payDetailTypeId == 0}" required>
                    <option *ngFor="let type of payDetailTypeList" value="{{type.payDetailTypeId}}">{{type.abbrev}} - {{type.description}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Quantity</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control" [(ngModel)]="payDetail.quantity" (change)="calcAmount()" [ngClass]="{'border-danger': payDetail.quantity == 0}" min="0" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Rate</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control" [(ngModel)]="payDetail.rate" min="0" (change)="calcAmount()" [ngClass]="{'border-danger': payDetail.rate == 0}" step="0.01" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Amount</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control" [(ngModel)]="payDetail.amount" min="0" [disabled]="true" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Notes</label>
            </div>
            <div class="col-sm-9">
                <textarea class="form-control" [(ngModel)]="payDetail.notes"></textarea>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 m-2">
            <button class="btn btn-primary m-2" (click)="save()" [disabled]="!isValid()">Save</button>
            <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': isLoading}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>